// Label of the Steam account on the activation steps. For a Quick Invite sign-in the
// backend returns the user with quickInvite only (no name, no avatar), so the link
// the client entered is shown instead of the name.
export default function accountLabel(user) {
  if (!user) return '';
  return user.name || user.quickInvite || '';
}
